import React from 'react';
import { usePlaylistArtwork } from '../../hooks/usePlaylistArtwork';

const PlaylistArtwork = ({ playlist, className = "w-full h-full" }) => {
  const { artworkUrls, isLoading } = usePlaylistArtwork(playlist);

  if (isLoading) {
    return <div className={`${className} bg-gray-200 dark:bg-brand-gray/20 animate-pulse rounded-md`}></div>;
  }

  // If no songs in playlist, show a fallback
  if (!artworkUrls || artworkUrls.length === 0) {
    return <div className={`${className} bg-gray-300 dark:bg-brand-gray/30 flex items-center justify-center rounded-md`}>
      <span className="text-[8px] text-gray-500 uppercase font-black">Empty</span>
    </div>;
  }

  if (artworkUrls.length === 4) {
    return (
      <div className={`grid grid-cols-2 grid-rows-2 overflow-hidden rounded-md ${className}`}>
        {artworkUrls.map((url, index) => (
          <img key={index} src={url} className="w-full h-full object-cover" alt="" />
        ))}
      </div>
    );
  }

  return (
    <img 
      src={artworkUrls[0]} 
      className={`${className} object-cover rounded-md`} 
      alt={playlist.name} 
    />
  );
};

export default PlaylistArtwork;